// Per-group role + membership row shapes.
import { z } from 'zod';
import { ProfileAvatarDesign, RoleId } from '../members/index.js';
// ---------------------------------------------------------------------------
// GroupRole — orthogonal to the global User-System role. Owner > Moderator > Member.
// ---------------------------------------------------------------------------
export const GroupRole = z.enum(['member', 'moderator', 'owner']);
// ---------------------------------------------------------------------------
// GroupMembership — (group_id, user_id) PK + role.
// ---------------------------------------------------------------------------
export const GroupMembership = z.object({
    groupId: z.string().uuid(),
    userId: z.string().uuid(),
    groupRole: GroupRole,
    joinedAt: z.string().datetime({ offset: true }),
    /** Display name resolved from the users table. Optional so single-row
     *  responses (admin-add, role-change) that don't need a join can omit
     *  it; the list endpoint always populates it. Falls back to a short
     *  derived initials slice in the UI when absent. */
    displayName: z.string().optional(),
    avatarDesign: ProfileAvatarDesign.optional(),
    primaryRole: RoleId.optional(),
    parentOf: z.array(z.string().uuid()).optional(),
    childOf: z.array(z.string().uuid()).optional(),
});
//# sourceMappingURL=membership.js.map